import type { Middleware } from '@reduxjs/toolkit';
import { fetchPriceRequest } from '../slice/pricesSlice';
import { RootState } from '../store';
import { getPriceCatalogKey } from '../../utils/equipment';

export const dedupeFetchPriceRequestMiddleware: Middleware = store => next => action => {
  if (action.type === fetchPriceRequest.type) {
    const state: RootState = store.getState();
    const priceCatalogKey = getPriceCatalogKey(action.payload.equipmentId);
    if (state.prices.fetchPriceQueue[priceCatalogKey]) {
        return;
    }
  }
  return next(action);
};